import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Field } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import getConfig from "next/config";
const {
  publicRuntimeConfig: { settings },
} = getConfig();

import InputCheckbox from "@components/Form/Checkbox";
import InputText from "@components/Form/InputText";
import Textarea from "@components/Form/Textarea";
import { addAlert } from "@store/app/actions";

import {
  composeFormValidators,
  isRequired,
  hasMinLength,
  hasMaxLength,
} from "@lib/validations";

import Button from "@components/Button";
import Heading from "@components/Heading";
import CloseIcon from "@components/Icons/Close";
import RatingStar from "@components/Icons/RatingStar";
import Alert from "@components/Alert";

import { trackProductReview } from "@store/tracker/actions";
import { apiCall } from "@store/app/actions";
import { postReviewsApi, postQuestionsApi } from "@lib/api/index";
import ProductReviewsFormPlaceholder from "@components/ProductReviews/ProductReviewsFormPlaceholder";

class AddReviewForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSent: false,
      titleValue: "",
      uploadedFiles: [],
      reviewsType: [],
      imagePreviewUrl: [],
    };
    this._isMounted = false;
    this.alertRef = React.createRef();
  }

  async componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  sendForm = async (values) => {
    const { type, productId, sku } = this.props;
    const { title, body, rating, termsAndContitions, types } = values;
    const typeId = types;
    const payload = {
      productId,
      body,
      typeId,
      sku,
    };
    if (type === "reviews") {
      payload.title = title;
      payload.typeId = types;
      payload.rating = parseInt(rating || 0);
      if (termsAndContitions) {
        payload.terms = termsAndContitions;
      }
      if (this.state.uploadedFiles.length > 0) {
        payload.images = this.state.uploadedFiles;
      }
    }
    const addResponse = await this.props.apiCall({
      spinner: true,
      alert: true,
      apiCall: type === "reviews" ? postReviewsApi : postQuestionsApi,
      apiArgs: [payload],
      returnResponse: true,
    });

    if (addResponse && addResponse.ok) {
      this.setState({
        isSent: true,
        uploadedFiles: [],
        imagePreviewUrl: [],
      });

      if (type === "reviews" && rating) {
        this.props.trackProductReview({ sku, rating: rating });
      }
    }

    // this.alertRef.current.closest("#reviews").scrollIntoView();
  };

  displayForm = () => {
    this.setState({
      isSent: false,
    });
  };

  setTitle(e) {
    this.setState({
      titleValue: e,
    });
  }

  handleFileUpload = (event) => {
    event.persist();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const fileType = file["type"];
      const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
      if (
        !validImageTypes.includes(fileType) ||
        file.name.split(".").find((element) => element === "jfif") ||
        file.name.split(".").find((element) => element === "gif")
      ) {
        this.props.addAlert({
          message: `Sunt permise doar fisiere de tipul JPEG, JPG si PNG`,
          variant: "error",
        });
        return;
      }
      if (file.size > 5242880) {
        event.target.value = "";
        this.props.addAlert({
          message: `Sunt permise doar fisiere care sunt mai mici de 5 MB`,
          variant: "error",
        });
        return;
      }

      // push images to state for client side display
      // make a copy of the object
      let images = [...this.state.imagePreviewUrl];
      // create img preview object used vor display and same file verification
      let imgFile = {
        name: event.target.files[0]["name"],
        objectPreview: URL.createObjectURL(file),
      };
      // check for duplicate file
      if (
        this.state.imagePreviewUrl.find((item) => item.name === imgFile.name)
      ) {
        // reset event value
        event.target.value = "";
        // display alert
        this.props.addAlert({
          message: `Fisier duplicat` + " " + imgFile.name,
          variant: "error",
        });
        return;
      }
      // put img object in imagePreview array
      images.push(imgFile);
      this.setState({
        imagePreviewUrl: images,
      });
      // push img file to state array that will be used for later upload
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let files = this.state.uploadedFiles;
        files.push(reader.result);
        this.setState({
          uploadedFiles: files,
        });
      };
      event.target.value = "";
    }
  };

  imageRemove = (key) => {
    let imgArray = [...this.state.imagePreviewUrl];
    let imgEncoded = [...this.state.uploadedFiles];
    imgArray.splice(key, 1);
    imgEncoded.splice(key, 1);
    this.setState({
      uploadedFiles: imgEncoded,
      imagePreviewUrl: imgArray,
    });
  };

  render() {
    const {
      counter,
      closeForm,
      type,
      placeholder,
      visibleForm,
      placeholder_label,
      user: { isLoggedIn },
    } = this.props;
    const { isSent } = this.state;
    let url = "";
    if (typeof window !== "undefined") {
      url = window.location.href.split("/#")[0] + "/#questions";
    }
    if (isSent) {
      return (
        <div ref={this.alertRef}>
          <Alert type="success" onClose={this.displayForm}>
            {type === "reviews"
              ? "Recenzia ta a fost adaugata. Iti multumim pentru contributie."
              : "Intrebarea ta a fost adaugata. Te vom anunta cand primesti un raspuns."}
          </Alert>
        </div>
      );
    }

    if (placeholder && !visibleForm) {
      return (
        <ProductReviewsFormPlaceholder
          label={placeholder_label}
          showLogin={false}
        />
      );
    } else if (!placeholder && visibleForm) {
      return (
        <div
          className={`lg:mb-4 pt-2px pb-10px md:py-27px lg:px-4 md:px-8 text-black relative ${
            isLoggedIn && !counter && type === "reviews" ? "md:bg-gray-102" : ""
          }`}
        >
          <div className={`lg:flex px-1`}>
            <div
              className={`absolute hidden items-center top-0 right-0 mt-15px mr-15px cursor-pointer
              ${type !== "reviews" || counter ? "" : "md:flex"}
              `}
              onClick={closeForm}
            >
              <div className="pr-1 text-sm font-medium">Inchide</div>
              <button className="rounded p-1 block appearance-none text-black">
                <CloseIcon width="15px" height="15px" />
              </button>
            </div>
            <div className="lg:w-736px lg:pr-4 mx-auto">
              <div
                className={`mb-2 ${
                  type !== "reviews"
                    ? "md:mb-1 font-normal leading-8 "
                    : "md:mb-0  "
                }`}
              >
                <Heading
                  title={
                    type === "reviews"
                      ? "Adauga o recenzie"
                      : "Adauga o intrebare"
                  }
                  as="h2"
                  display="h2"
                />
              </div>
              {isLoggedIn && (
                <Form
                  onSubmit={this.sendForm}
                  mutators={{
                    setTitleOne: (args, state, utils) => {
                      utils.changeValue(state, "title", () => `Imi place`);
                    },
                    setTitleTwo: (args, state, utils) => {
                      utils.changeValue(state, "title", () => `Merita`);
                    },
                    setTitleThree: (args, state, utils) => {
                      utils.changeValue(state, "title", () => `Bun`);
                    },
                    setTitleFour: (args, state, utils) => {
                      utils.changeValue(state, "title", () => `Recomand`);
                    },
                    setTitleFive: (args, state, utils) => {
                      utils.changeValue(state, "title", () => `Acceptabil`);
                    },
                  }}
                  render={({
                    handleSubmit,
                    form,
                    values,
                    submitting,
                    pristine,
                    errors,
                    touched,
                  }) => {
                    return (
                      <form onSubmit={handleSubmit} noValidate={true}>
                        {type === "reviews" && (
                          <>
                            <div className="flex items-center lg:mt-1 mb-2">
                              {[1, 2, 3, 4, 5].map((starVal) => (
                                <Field
                                  key={`star-item-${starVal}`}
                                  name="rating"
                                  label={
                                    <RatingStar
                                      width="23px"
                                      height="21px"
                                      className={`mr-3px cursor-pointer ${
                                        values &&
                                        values.rating &&
                                        values.rating >= starVal
                                          ? "text-yellow"
                                          : "text-gray-200"
                                      }`}
                                    />
                                  }
                                  type="radio"
                                  value={starVal}
                                  validate={isRequired()}
                                >
                                  {(props) => (
                                    <label className="Form-radio m-0 p-0">
                                      <input
                                        {...props.input}
                                        type="radio"
                                        disabled={props.disabled}
                                        className="checkbox-input opacity-0 w-0 h-0"
                                      />
                                      {typeof props.label === "string" ? (
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: props.label,
                                          }}
                                        ></span>
                                      ) : (
                                        props.label
                                      )}
                                    </label>
                                  )}
                                </Field>
                              ))}
                            </div>

                            {errors.rating && touched.rating && (
                              <div className="text-red-brand text-sm">
                                {errors.rating}
                              </div>
                            )}
                          </>
                        )}
                        <div className="mt-6 lg:w-full">
                          {/* Field Title */}
                          {type === "reviews" && (
                            <>
                              <div>
                                <label
                                  htmlFor="review_title"
                                  className="Form-label is-required inline-block font-medium text-sm leading-4 mb-3"
                                >
                                  Titlul recenziei
                                </label>
                                <span className="inline-block mb-1 ml-1 text-gray-light font-normal text-sm leading-4">
                                  (3 — 150 characters)
                                </span>
                              </div>
                              <Field
                                name="title"
                                id="review_title"
                                component={InputText}
                                value={this.state.titleValue}
                                inputClassName="max-w-fulli"
                                validate={composeFormValidators(
                                  isRequired(),
                                  hasMinLength(3),
                                  hasMaxLength(150)
                                )}
                              />
                            </>
                          )}
                        </div>
                        <div className="mt-6">
                          {type === "reviews" && (
                            <>
                              <div>
                                <label
                                  htmlFor="review_title_suggestions"
                                  className="Form-label inline-block font-medium text-sm leading-4 mb-3"
                                >
                                  Sugestii titlu
                                </label>

                                <div className="font-normal text-sm">
                                  <button
                                    type="button"
                                    className="bg-orange-dark mt-1 mr-10px py-1 px-3 rounded-full"
                                    onMouseDown={form.mutators.setTitleOne}
                                  >
                                    Imi place
                                  </button>
                                  <button
                                    type="button"
                                    className="bg-orange-dark mt-1 mr-10px py-1 px-3 rounded-full"
                                    onMouseDown={form.mutators.setTitleTwo}
                                  >
                                    Merita
                                  </button>
                                  <button
                                    type="button"
                                    className="bg-orange-dark mt-1 mr-10px py-1 px-3 rounded-full"
                                    onMouseDown={form.mutators.setTitleThree}
                                  >
                                    Bun
                                  </button>
                                  <button
                                    type="button"
                                    className="bg-orange-dark mt-1 mr-10px py-1 px-3 rounded-full"
                                    onMouseDown={form.mutators.setTitleFour}
                                  >
                                    Recomand
                                  </button>
                                  <button
                                    type="button"
                                    className="bg-orange-dark mt-1 mr-10px py-1 px-3 rounded-full"
                                    onMouseDown={form.mutators.setTitleFive}
                                  >
                                    Acceptabil
                                  </button>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="mt-6  lg:w-full">
                          {/* Taxtarea for the review */}
                          <div>
                            <label
                              htmlFor="body"
                              className="Form-label is-required inline-block font-bold"
                            >
                              {type === "reviews" ? (
                                <span className="font-medium text-sm leading-4 mb-3">
                                  Recenzie
                                </span>
                              ) : (
                                <span>Intrebare</span>
                              )}
                            </label>
                            {type !== "reviews" ? (
                              <span className="inline-block mb-1 ml-1 text-gray-light">
                                (2 — 1000 de caractere)
                              </span>
                            ) : (
                              <span className="inline-block mb-1 ml-1 text-gray-light font-normal text-sm leading-4">
                                (30 — 3000 de caractere)
                              </span>
                            )}
                          </div>
                          <Field
                            name="body"
                            id="review_body"
                            component={Textarea}
                            inputClassName="max-w-fulli"
                            rows="6"
                            validate={composeFormValidators(
                              isRequired(),
                              hasMinLength(type === "reviews" ? 30 : 2),
                              hasMaxLength(type === "reviews" ? 3000 : 1000)
                            )}
                          />
                        </div>
                        <div className="mt-6">
                          {type === "reviews" && (
                            <div className="flex items-center text-sm font-normal p-2 rounded bg-gray-100 mb-3 lg:w-full">
                              <div className="grow">
                                Daca ai o intrebare legata de produs, te rugam
                                sa o adaugi in sectiunea
                                <span className="font-bold text-sm text-red-lightdark">
                                  &nbsp;<a href={url}>Intrebari</a>
                                </span>
                                .
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="mt-6">
                          {type === "reviews" &&
                            {
                              /* Upload Section */
                            } && (
                              <div>
                                <label
                                  htmlFor="review_title_suggestions"
                                  className="Form-label inline-block font-medium text-sm leading-4 mb-3"
                                >
                                  Adauga imagine
                                  <span className="inline-block mb-1 ml-1 text-gray-light  font-normal text-sm leading-4">
                                    (maximum 5 imagini)
                                  </span>
                                </label>
                                <div className="flex justify-start gap-2">
                                  <div className="flex">
                                    <label
                                      className={`${
                                        this.state.imagePreviewUrl.length > 4
                                          ? `disabled`
                                          : ``
                                      } place-content-center flex flex-col w-48px h-48px items-center bg-gray-100 rounded-md border border-gray-light tracking-wide cursor-pointer hover:bg-gray-101`}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6 text-red-lightdark"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                        />
                                      </svg>
                                      <input
                                        id="attachment"
                                        name="attachment"
                                        type="file"
                                        className="hidden"
                                        // iOS Safari 12 supports only image/* types
                                        accept="image/jpg,image/png,image/jpeg"
                                        disabled={
                                          this.state.imagePreviewUrl.length > 4
                                            ? true
                                            : false
                                        }
                                        ref={this.attachmentInput}
                                        onChange={this.handleFileUpload}
                                      />
                                    </label>
                                  </div>
                                  {/* Image tumbnail cards / max 5 */}
                                  {this.state.imagePreviewUrl.length > 0 &&
                                    this.state.imagePreviewUrl.map(
                                      (item, key) => {
                                        return (
                                          <div key={key.toString() + "0"}>
                                            <div
                                              key={key.toString() + "1"}
                                              className="absolute ml-8 -mt-2 bg-gray-1300 rounded-xl cursor-pointer"
                                              onClick={() =>
                                                this.imageRemove(key)
                                              }
                                            >
                                              <svg
                                                key={key.toString() + "2"}
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5  rotate-45"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                              >
                                                <path
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeWidth="2"
                                                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                                />
                                              </svg>
                                            </div>
                                            <label
                                              key={key.toString() + "3"}
                                              className="items-center bg-gray-100 rounded-md tracking-wide hover:bg-gray-101 h-48px w-48px"
                                            >
                                              <img
                                                className="w-48px h-48px rounded-md object-cover"
                                                src={item.objectPreview}
                                                alt={key.toString() + "4"}
                                              />
                                            </label>
                                          </div>
                                        );
                                      }
                                    )}
                                </div>
                              </div>
                            )}
                        </div>
                        {/* Upload section end */}
                        <div className="mt-6">
                          {/* Terms and conditions & GDPR */}
                          {type === "reviews" && (
                            <>
                              <OnChange name="termsAndContitions">
                                {(value) => {
                                  if (value && values["recommendYes"]) {
                                    form.reset({
                                      ...values,
                                      termsAndContitions: true,
                                    });
                                  }
                                }}
                              </OnChange>
                              <Field
                                name="termsAndContitions"
                                component={InputCheckbox}
                                type="checkbox"
                                required
                                label={
                                  <span className="inline-block mb-1 ml-1 font-normal text-sm">
                                    Prin adaugarea acestui review sunt de acord
                                    cu
                                    {` `}
                                    <a
                                      href={`${settings.baseUrl}/suport-clienti/informatii-generale-termeni-si-conditii/`}
                                      title="Termenii si Conditiile"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="font-bold text-sm text-red-lightdark"
                                    >
                                      Termenii si Conditiile*
                                    </a>
                                  </span>
                                }
                                validate={isRequired()}
                              />
                              <OnChange name="gdpr">
                                {(value) => {
                                  if (value && values["recommendYes"]) {
                                    form.reset({
                                      ...values,
                                      termsAndContitions: true,
                                    });
                                  }
                                }}
                              </OnChange>
                              <Field
                                name="gdpr"
                                component={InputCheckbox}
                                type="checkbox"
                                required
                                label={
                                  <span className="inline-block mb-1 ml-1 font-normal text-sm">
                                    Sunt de acord cu
                                    {` `}
                                    <a
                                      href={`${settings.baseUrl}/nota-informare-date-caracter-personal/pag/`}
                                      title="Politica GDPR"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="font-bold text-sm text-red-lightdark"
                                    >
                                      politica GDPR*
                                    </a>
                                  </span>
                                }
                                validate={isRequired()}
                              />
                            </>
                          )}
                          {/* End of Terms and conditions */}
                        </div>

                        <div className="md:flex items-center mt-4 lg:mb-12 sm:mb-6">
                          <div
                            className={`hidden md:block ${
                              type !== "reviews" ? "md:w-190px" : "md:w-200px"
                            } `}
                          >
                            <Button
                              title={
                                type === "reviews"
                                  ? "Adauga recenzia ta"
                                  : "Trimite intrebarea ta"
                              }
                              type="submit"
                              display="block"
                              size="normal"
                            />
                          </div>

                          <div className="md:hidden">
                            <Button
                              title={
                                type === "reviews"
                                  ? "Adauga recenzia ta"
                                  : "Trimite intrebarea ta"
                              }
                              size="normal"
                              display="block"
                              type="submit"
                              disabled={submitting || pristine}
                            />
                          </div>

                          <div className="md:hidden md:ml-4 text-center mt-4 md:mt-0">
                            <button
                              className={`text-red-brand font-bold focus:outline-none focus:underline hover:underline
                                          ${counter ? "hidden" : ""}
                                        `}
                              type="button"
                              onClick={closeForm}
                            >
                              Renunta
                            </button>
                          </div>
                        </div>
                      </form>
                    );
                  }}
                />
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return "";
    }
  }
}

export default connect(
  (state) => ({
    user: state.user,
  }),
  {
    apiCall,
    trackProductReview,
    addAlert,
  }
)(AddReviewForm);
